<template>
  <div>
    <v-list>
      <v-list-item two-line>
        <v-list-item-avatar tile size="200" color="grey">
          <v-img :src="props_image">
            <v-spacer></v-spacer>
            <v-btn dark icon class="mr-4">
              <v-icon @click="uploadDialog = true">mdi-pencil</v-icon>
            </v-btn>
          </v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <div class="overline mb-4">PERSONAL</div>
          <v-list-item-title class="headline"
            >{{ props_data.firstname }} {{ props_data.lastname }}
          </v-list-item-title>
          <v-list-item-subtitle>Fullname</v-list-item-subtitle>

          <v-list-item-title class="headline"
            >Is a {{ props_data.relationship }} to {{ props_data.staff_member }}
          </v-list-item-title>
          <v-list-item-subtitle
            >What you need to know about {{ props_data.firstname }}
            {{ props_data.lastname }}.</v-list-item-subtitle
          >

          <v-list-item-title class="headline">
            <v-chip
              class="ma-2"
              color="teal"
              text-color="white"
              v-if="props_data.insurance_status == '1'"
            >
              <v-avatar left>
                <v-icon>mdi-checkbox-marked-circle</v-icon>
              </v-avatar>
              Active
            </v-chip>

            <v-chip
              class="ma-2"
              color="red"
              text-color="white"
              v-if="props_data.insurance_status == '0'"
            >
              <v-avatar left>
                <v-icon>mdi-alert-circle</v-icon>
              </v-avatar>
              Inactive
            </v-chip>
          </v-list-item-title>
          <v-list-item-subtitle>Insurance Status</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <v-list class="transparent d-flex flex-column mb-6" flat tile>
      <v-list-item>
        <v-list-item-title>Insuarnce No..</v-list-item-title>
        <v-list-item-subtitle>{{
          props_data.insurance_no
        }}</v-list-item-subtitle>
      </v-list-item>

      <v-list-item>
        <v-list-item-title>Insuarnce Issued Date..</v-list-item-title>
        <v-list-item-subtitle>{{
          props_data.insurance_iss_date | formatShortDate
        }}</v-list-item-subtitle>
      </v-list-item>

      <v-list-item>
        <v-list-item-title>Insurance Expiry Date.</v-list-item-title>
        <v-list-item-subtitle>{{
          props_data.insurance_exp_date | formatShortDate
        }}</v-list-item-subtitle>
      </v-list-item>

      <v-list-item>
        <v-list-item-title>Date of Birth</v-list-item-title>
        <v-list-item-subtitle>{{
          props_data.dob | formatShortDate
        }}</v-list-item-subtitle>
      </v-list-item>
    </v-list>
    <v-dialog v-model="uploadDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <span>Upload Image</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <v-card class="d-flex flex-row" flat tile>
            <v-img :src="imageUrl" height="100" width="50" v-if="imageUrl" />
            <v-spacer></v-spacer>

            <v-file-input
              label="File input"
              v-model="image"
              @change="getImageChange"
              prepend-icon="mdi-camera"
            >
            </v-file-input>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="uploadDialog = false">
            Close
          </v-btn>
          <v-btn color="primary" @click="uploadImage(props_data.id)"
            >Upload and save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_progress" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="subtitle-1 text-center">
          processing request, please wait...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ImageService from "@/services/image.service";
import { UPLOAD_IMAGE_DEPENDENT } from "@/store/modules/actions.type";
export default {
  name: "dependentdetailviewcard",
  props: ["props_data", "props_image"],
  data: () => ({
    imageUrl: null,
    image: null,
    base64Image: null,
    uploadDialog: false,
    dialog_progress: false
  }),
  created() {
    //console.log(this.props_data);
  },
  methods: {
    submit(slug, data) {
      this.dialog_progress = true;
      this.$store
        .dispatch(UPLOAD_IMAGE_DEPENDENT, { slug, data })
        .then(() => {
          this.dialog_progress = false;
          this.$noty.success("Image upload completed!");
          this.uploadDialog = false;
        })
        .catch(({ response }) => {
          this.errors = response.data;
        });
    },
    uploadImage(_id) {
      if (this.base64Image) this.submit(_id, this.base64Image);
    },
    getImageChange(e) {
      ImageService.getBase64Image(e).then(result => {
        this.base64Image = result;
        this.imageUrl = this.base64Image;
      });
    }
  }
};
</script>
